(function(){
  'use strict';

  // ===== HEADER SCROLL EFFECT =====
  const header = document.getElementById('header');
  let lastScroll = 0;
  window.addEventListener('scroll', function(){
    if(window.scrollY > 50){
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }, {passive:true});

  // ===== MOBILE MENU =====
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobileMenu');
  const mobileClose = document.getElementById('mobileClose');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function(){
      this.classList.toggle('active');
      mobileMenu.classList.toggle('open');
      document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
    });
    if (mobileClose) {
      mobileClose.addEventListener('click', function(){
        hamburger.classList.remove('active');
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    }
    mobileMenu.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){
        hamburger.classList.remove('active');
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ===== INTERACTIVE DIAMOND SHAPE SELECTOR =====
  const shapeItems = document.querySelectorAll('.shape-item');
  const ringDisplay = document.getElementById('shapeRingDisplay');
  const ringImg = ringDisplay ? ringDisplay.querySelector('img') : null;

  // Pre-load all ring images
  shapeItems.forEach(function(item){
    const ringUrl = item.getAttribute('data-ring');
    if(ringUrl){ const preload = new Image(); preload.src = ringUrl; }
  });

  shapeItems.forEach(function(item){
    item.addEventListener('mouseenter', function(){
      const ringUrl = this.getAttribute('data-ring');

      // Remove active from all
      shapeItems.forEach(function(s){ s.classList.remove('active'); });
      // Add active to hovered
      this.classList.add('active');

      // Crossfade ring image
      if(ringImg && ringUrl){
        ringImg.style.opacity = '0';
        setTimeout(function(){
          ringImg.src = ringUrl;
          ringImg.style.opacity = '1';
        }, 200);
      }
    });
    // Also support click for mobile
    item.addEventListener('click', function(){
      const ringUrl = this.getAttribute('data-ring');
      shapeItems.forEach(function(s){ s.classList.remove('active'); });
      this.classList.add('active');
      if(ringImg && ringUrl){
        ringImg.style.opacity = '0';
        setTimeout(function(){
          ringImg.src = ringUrl;
          ringImg.style.opacity = '1';
        }, 200);
      }
    });
  });

  // ===== BEST SELLERS CAROUSEL =====
  const track = document.getElementById('carouselTrack');
  const prevBtn = document.getElementById('carouselPrev');
  const nextBtn = document.getElementById('carouselNext');
  const scrollAmount = 304; // card width + gap

  if (track && prevBtn && nextBtn) {
    prevBtn.addEventListener('click', function(){
      track.scrollBy({left: scrollAmount, behavior:'smooth'});
    });
    nextBtn.addEventListener('click', function(){
      track.scrollBy({left: -scrollAmount, behavior:'smooth'});
    });

    // ===== CATEGORY FILTER TABS =====
    var allCards = Array.from(track.querySelectorAll('.product-card'));
    document.querySelectorAll('.category-tab').forEach(function(tab){
      tab.addEventListener('click', function(){
        document.querySelectorAll('.category-tab').forEach(function(t){ t.classList.remove('active'); });
        this.classList.add('active');
        var cat = this.getAttribute('data-cat');
        allCards.forEach(function(card){
          if(cat === 'all' || card.getAttribute('data-category') === cat){
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
        track.scrollTo({left: 0, behavior:'smooth'});
      });
    });
  }

  // ===== FAQ ACCORDION =====
  document.querySelectorAll('.faq-question').forEach(function(btn){
    btn.addEventListener('click', function(){
      const item = this.parentElement;
      const answer = item.querySelector('.faq-answer');
      const isOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.faq-item').forEach(function(fi){
        fi.classList.remove('open');
        fi.querySelector('.faq-answer').style.maxHeight = null;
      });

      // Open clicked if it was closed
      if(!isOpen){
        item.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  // ===== SCROLL FADE-UP ANIMATIONS =====
  const observerOptions = {
    threshold: 0,
    rootMargin: '0px 0px 200px 0px'
  };
  const observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  var fadeEls = document.querySelectorAll('.fade-up');
  fadeEls.forEach(function(el){ observer.observe(el); });

  // Fallback: check on scroll + initial load
  function checkFadeUp(){
    fadeEls.forEach(function(el){
      if(!el.classList.contains('visible')){
        var rect = el.getBoundingClientRect();
        if(rect.top < window.innerHeight + 100 && rect.bottom > -100){
          el.classList.add('visible');
        }
      }
    });
  }
  window.addEventListener('scroll', checkFadeUp, {passive:true});
  setTimeout(checkFadeUp, 100);
  setTimeout(checkFadeUp, 500);

})();
